export default __webpack_public_path__ + "static/media/t500.d18e2738.glb";